<template>
  <section
    class="dashboard-view relative overflow-hidden"
    style="background-color: var(--page-background) !important"
    :class="{ mobile: getIsMobile, 'is-open': isCollapse }"
  >
    <div class="absolute -top-36 -left-36">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -right-36 -top-36">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -bottom-40 -right-40">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -bottom-44 -left-44">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>

    <!-- Topbar positioned with proper z-index -->
    <div class="topbar-container">
      <TopbarDefault />
    </div>

    <!-- Main content area -->
    <div class="main-content-container">
      <div class="canvas">
        <main
          id="MainLayout"
          class="main-dashboard-view main-dashboard-view-with-sidebar !p-0 !mx-3 page-background h-[calc(100vh-70px)] !rounded-xl !border !border-page-border overflow-y-auto overflow-x-hidden bg-white"
        >
          <!-- <router-view :layout.sync="layout" /> -->
          <SideLayout />
        </main>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TopbarDefault from '../layouts/TopbarDefault';
  import SideLayout from '../components/Configuration/layout';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';
  export default {
    name: 'home',
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      if (this.getIsMobile) {
        this.$store.commit('navigationOpen/setIsOpen', false, {
          root: true,
        });
      }
    },
    components: {
      TopbarDefault,
      SideLayout,
    },
    mixins: [MobileRelatedHelper],
    computed: {
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('menuManagementV2', [
        'getMenu',
        'getMenuManagementAddStatus',
        'getMenuManagementUpdateStatus',
      ]),
      ...mapGetters('auth', [
        'getActiveWorkspace',
        'getAuthenticationDetails',
        'getAuthenticatedSSOToken',
      ]),
      ...mapGetters('company', ['getContactLoginSlug', 'getUpdateCompany', 'getCompanyDetails']),
      ...mapGetters('sso', ['getAuthenticatedSSOToken']),
      isCollapse: {
        get() {
          return this.getIsOpen;
        },
        set(isCollapse) {
          this.$store.commit('navigationOpen/setIsOpen', isCollapse, {
            root: true,
          });
        },
      },
    },
    data() {
      return {
        layout: 'div',
        offCanvas: true,
        sidebarStatus: false,
        windowWidth: 1500,
        isHorMenu: false,
        copyModal: false,
        getlink: '',
        activeTab: 'first',
        publicLink: '',
        privateLink: '',
      };
    },
    methods: {
      async getCompanyInfo() {
        try {
          if (this.getCompanyDetails) {
            this.brandingInfo = this.getCompanyDetails;
          }
        } catch (e) {
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: e,
          });
        }
      },
      openViewConfigPage() {
        this.copyModal = true;
      },
      copyLinkToClipboard(refName) {
        this.$refs[refName].focus();
        document.execCommand('copy');
        this.$message.success('Link copied to clipboard');
      },
    },
  };
</script>

<style lang="scss">
  .dashboard-view {
    &.mobile {
      &.is-open {
        .bg-canvas {
          display: block;
        }
      }

      .main-dashboard-view {
        padding-left: 30px;
      }

      .left-side-bar {
        position: absolute;
        z-index: 11000;
      }

      .offCanvas {
        margin-left: 0px;
        // background: rgba(0, 0, 0, .025);
      }

      .bg-canvas {
        background: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        width: 100vw;
        height: 100vh;
        position: absolute;
        border: 1px solid red;
        top: 0;
        left: 0;
        display: none;
      }
    }
  }

  .dashboard-view {
    min-height: 100vh;
    z-index: 999;
    // Topbar container with proper z-index
    .topbar-container {
      position: relative;
      z-index: 1000;
      width: 100%;
    }

    // Main content container
    .main-content-container {
      position: relative;
      z-index: 1;
      width: 100%;
    }

    .main-dashboard-view {
      margin-top: 50px;
      padding-top: 70px !important;
      padding-left: 80px;
      padding-right: 12px;
    }

    .main-dashboard-view-with-sidebar {
      margin-top: 46px !important;
      padding-top: 2% !important;
      padding-left: 5% !important;
    }

    .edit-new-template-view {
      padding-left: 0;
    }

    .canvas {
      transition: all 0.2s ease-in-out;
    }

    .offCanvas {
      margin-left: 150px;
      transition: all 0.2s ease-in-out;
    }

    .icon-link {
      font-size: 24px;
      float: right;
    }
  }
</style>
